@use "../../styles/breakpoint.module.scss" as *;

.section {
    composes: container from "../../styles/composable/layout.module.css";
    margin-bottom: var(--spacer-40);
}

:nth-last-child(1 of .section) {
    margin-bottom: 0;
}

.heading {
    composes: fontHeader24 from "../../styles/composable/typography.module.css";
    margin-bottom: var(--spacer-24);
}

.tiles {
    composes: grid from "../../styles/composable/layout.module.css";

    > * {
        grid-column: span 3;

        @media ($below-tablet) {
            grid-column: span 4;
        }

        @media ($below-mobile) {
            grid-column: span 2;
        }
    }
}
